import { FlexBox } from '@fable/components'
import { css } from '@fable/theme'
import { AvgRatingBars, MostReadAuthors, MostReadGenres } from '../charts'
import { GenreStream, RatingComparison } from '../charts/advanced_charts'

export const StatsProfileHabits = () => {
  return (
    <FlexBox
      className={css`
        width: 100%;
        gap: 20px;
      `}
      flexDirection="column"
    >
      <MostReadGenres />
      <GenreStream />
      <AvgRatingBars />
      <RatingComparison />
      <MostReadAuthors />
    </FlexBox>
  )
}
